<div class="custom-sections-container">
  <app-erc-custom-values-display
  [title]="'Owners'"
  [dataList]="dataListErcContacts"
  [loading]="loading"
  [convertToFormlyDialogData]="ercContactsToFormlyDialogData"
  [saveModel]="ercContactsSaveModel"
  [dialogWidth]="'25rem'"
  [borrowerId]="borrowerId"
  ></app-erc-custom-values-display>
  <app-erc-custom-values-display
  [title]="'Employee Relationships'"
  [dataList]="dataListContactEmployeeRelationships"
  [ercContacts]="ercContacts"
  [convertToFormlyDialogData]="employeeRelationshipsToDialogData"
  [saveModel]="relationshipsEmployeeSaveModel"
  [dialogWidth]="'55rem'"
  [loading]="loading"
  [borrowerId]="borrowerId"
  ></app-erc-custom-values-display>
  <app-erc-custom-values-display
  [title]="'Owner Relationships'"
  [dataList]="dataListContactOwnerRelationships"
  [ercContacts]="ercContacts"
  [convertToFormlyDialogData]="ownerRelationshipsToDialogData"
  [saveModel]="relationshipsOwnerSaveModel"
  [dialogWidth]="'55rem'"
  [loading]="loading"
  [borrowerId]="borrowerId"
  ></app-erc-custom-values-display>
</div>